<template>
  <div class="min-h-screen bg-background-light flex items-center justify-center p-4 sm:p-6">

    <div class="w-full max-w-[440px] flex flex-col items-center">

      <!-- Logo -->
      <div class="mb-5 sm:mb-6 flex items-center gap-2.5">
        <img src="/images/logo1.png" style="height: 5rem;">
      </div>

      <!-- Card -->
      <div class="w-full bg-white border border-slate-200 rounded-xl p-5 sm:p-6 soft-shadow">

        <!-- Header -->
        <div class="text-center mb-4 sm:mb-5">
          <h1 class="text-slate-900 text-2xl font-bold mb-2">
            Welcome Back
          </h1>
          <p class="text-slate-500 text-sm">
            Manage your reviews & reputation
          </p>
        </div>

        <!-- Form -->
        <form class="space-y-3 sm:space-y-4" @submit.prevent="login">

          <!-- Email -->
          <div class="space-y-2">
            <label class="text-sm font-medium text-slate-700">
              Email Address
            </label>

            <input
              v-model="form.email"
              type="email"
              placeholder="name@company.com"
              class="w-full px-4 py-2.5 rounded-lg border border-slate-200
                     focus:ring-2 focus:ring-primary/20 focus:border-primary
                     outline-none transition-all"
            />
          </div>

          <!-- Password -->
          <div class="space-y-2">
            <label class="text-sm font-medium text-slate-700">
              Password
            </label>

            <div class="relative">
              <input
                v-model="form.password"
                :type="showPassword ? 'text' : 'password'"
                placeholder="••••••••"
                class="w-full px-4 py-2.5 rounded-lg border border-slate-200
                       focus:ring-2 focus:ring-primary/20 focus:border-primary
                       outline-none transition-all"
              />

              <button
                type="button"
                @click="showPassword = !showPassword"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
              >
                <span class="material-symbols-outlined text-[20px]">
                  {{ showPassword ? 'visibility_off' : 'visibility' }}
                </span>
              </button>
            </div>
          </div>

          <!-- Remember / Forgot -->
          <div class="flex items-center justify-between text-sm">

            <label class="flex items-center gap-2 cursor-pointer">
              <input
                v-model="form.remember"
                type="checkbox"
                class="size-4 border border-slate-300 rounded
                       checked:bg-primary checked:border-primary"
              />
              <span class="text-slate-600">Remember me</span>
            </label>

            <a href="javascript:void(0)" @click="forgotNow()" class="text-primary font-medium hover:underline">
              Forgot password?
            </a>
          </div>

          <!-- Button -->
          <button
            :disabled="loading"
            class="w-full bg-primary hover:bg-primary/90 text-white
                  font-semibold py-2.5 rounded-lg transition-all
                  active:scale-[0.98]"
          >
            {{ loading ? "Signing In..." : "Sign In" }}
          </button>
        </form>

        <!-- Divider -->
        <div class="relative my-4 sm:my-5">
          <div class="absolute inset-0 flex items-center">
            <div class="w-full border-t border-slate-100"></div>
          </div>

          <div class="relative flex justify-center text-xs uppercase">
            <span class="bg-white px-3 text-slate-400">
              Or continue with
            </span>
          </div>
        </div>

        <!-- Social -->
        <div class="grid grid-cols-1 gap-3 sm:gap-4">

        <button @click="loginGnow()" class="social-btn google-btn">
            <svg class="size-5" viewBox="0 0 48 48">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.72 1.22 9.22 3.6l6.86-6.86C35.9 2.54 30.3 0 24 0 14.64 0 6.6 5.48 2.64 13.44l7.98 6.2C12.5 13.2 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.5 24.5c0-1.64-.14-3.22-.42-4.74H24v9.02h12.7c-.54 2.9-2.16 5.36-4.6 7.02l7.2 5.6c4.2-3.88 6.6-9.6 6.6-16.9z"/>
            <path fill="#FBBC05" d="M10.62 28.64A14.9 14.9 0 019.5 24c0-1.62.28-3.2.78-4.64l-7.98-6.2A23.96 23.96 0 000 24c0 3.86.92 7.5 2.64 10.56l7.98-6.2z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.9-2.14 15.86-5.82l-7.2-5.6c-2 1.34-4.56 2.14-8.66 2.14-6.26 0-11.5-3.7-13.38-8.94l-7.98 6.2C6.6 42.52 14.64 48 24 48z"/>
            </svg>

            Continue with Google
        </button>

        </div>

      </div>

      <!-- Bottom -->
      <p class="mt-4 sm:mt-5 text-sm text-slate-600 text-center">
        Don't have an account?
        <a href="javascript:void(0)" @click="signupNow()" class="text-primary font-semibold hover:underline">
          Create Account
        </a>
      </p>

      <!-- Footer -->
      <footer class="mt-6 sm:mt-8 flex flex-wrap justify-center gap-4 sm:gap-6 text-xs text-slate-400">
        <a href="https://reviewsfix.com/privacy-policy">Privacy Policy</a>
        <a href="https://reviewsfix.com/terms-of-use">Terms of Service</a>
        <a href="https://reviewsfix.com/contact/">Help Center</a>
      </footer>

    </div>
  </div>
</template>

<script>
import { apiBaseUrl } from "@/apis/appconst";
import { loginUser } from "@/apis/userapis";
import {useToast} from 'vue-toastification';

export default {
  data() {
    return {
      showPassword: false,
      loading: false,
      toast:null,
      refBy:"",
      form: {
        email: '',
        password: '',
        type: 'user',
        remember: false
      }
    }
  },
  mounted(){
    this.toast = useToast();
    const params = new URLSearchParams(window.location.search);
    const refBy = params.get("refBy");
    if (refBy) {
      console.log("Referral By:", refBy);

      this.refBy = refBy;   // store in data if needed
    }

    
    const udata = params.get("udata");
    if (udata) {
      const ldata = atob(udata);
      if (ldata.length > 0) {
        sessionStorage.setItem("ldata", ldata);
        window.location.href = "/";
      }
    }
  },
  methods: {
    loginGnow(){
      window.location.href = apiBaseUrl+"google_login";
    },
    async login() {

      // ✅ BASIC VALIDATION
      if (!this.form.email || !this.form.password) {
        this.toast.warning("Email and password required");
        return;
      }

      this.loading = true;

      try {

        // =========================
        // API CALL
        // =========================
        const res = await loginUser(
          this.form.email,
          this.form.password
        );

        if (!res.status) {
          this.toast.error(res.success || "Invalid login");
          this.loading = false;
          return;
        }

        const user = res.user;

        // =========================
        // STORE SESSION
        // =========================
        sessionStorage.setItem("ldata", JSON.stringify(user));

        window.location.href = "/";

      } catch (error) {

        console.error(error);
        this.toast.error("Login failed");

      }

      this.loading = false;
    },

    forgotNow() {
      if(this.refBy.length>0){
        window.location.href = "/forgot-password?refBy="+this.refBy;
      }
      else{
        window.location.href = "/forgot-password";
      }
    },

    signupNow() {
      if(this.refBy.length>0){
        window.location.href = "/create-account?refBy="+this.refBy;
      }
      else{
        window.location.href = "/create-account";
      }
    }
  }
}
</script>
<style scoped>
.soft-shadow {
  box-shadow:
    0 1px 3px rgba(0,0,0,0.08),
    0 20px 25px rgba(0,0,0,0.03);
}

/* Social buttons */
.social-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.7rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.social-btn:hover {
  background: #f8fafc;
}

/* ================= MOBILE POLISH ================= */

@media (max-width: 640px) {

  h1 {
    font-size: 1.4rem;
  }

  input {
    padding: 0.75rem !important;
  }

  button {
    padding: 0.75rem !important;
  }

}
.google-btn {
  font-weight: 500;
}

.google-btn svg {
  flex-shrink: 0;
}

</style>